export class MalformedPathError extends Error {}
